/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Recreate_Confirm_SubmitInputs */

const vi_order_recreate_confirm_submit = /** @type {(inputs: Order_Recreate_Confirm_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ và tạo lại`)
};

/**

* @param {Order_Recreate_Confirm_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_recreate_confirm_submit = /** @type {((inputs?: Order_Recreate_Confirm_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Recreate_Confirm_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_recreate_confirm_submit(inputs)
});